import type { CSSProperties } from "react";
import { t } from "../i18n";

// Thin lines in a voice-like profile, taller toward the centre, that rise and
// fall in place with the level.
const lines = Array.from({ length: 33 }, (_, index) => {
  const centre = Math.sin((Math.PI * (index + 0.5)) / 33);
  return (
    0.9 * (0.35 + 0.65 * centre) * (0.6 + 0.4 * Math.abs(Math.sin(index * 2.4)))
  );
});

export function AudioMeter({ level }: { level: number }) {
  return (
    <div
      className="audio-meter"
      role="meter"
      aria-label={t("مستوى صوت الميكروفون")}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(level * 100)}
      style={{ "--level": level } as CSSProperties}
    >
      {lines.map((height, index) => (
        <i key={index} style={{ "--height": height } as CSSProperties} />
      ))}
    </div>
  );
}
